import styled from "styled-components";

export const LoaderImage = styled.img`
    width: 50px;
    height: 50px;
`;